import React from "react";
import { Pie, Doughnut, Chart } from "react-chartjs-2";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import assetHomeIcon from "../../../assets/images/goal.png";
import moment from "moment";
import "../GoalsDashboard/GoalsDashboard.css";
import { chartColors } from "../../../components/form/debtPayOff/components/color";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { Menu, Dropdown } from "antd";
import { useHistory } from "react-router-dom";

export const GoalsDetails = ({ data, keyIndex, deleteGoal, taxInfo }) => {
  const history = useHistory();
  // var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
  // Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
  //   draw: function () {
  //     originalDoughnutDraw.apply(this, arguments);

  //     var chart = this.chart.chart;
  //     var ctx = chart.ctx;
  //     var width = chart.width;
  //     var height = chart.height;

  //     var text = chart.config.data.text;
  //     // console.log(chart, ctx)

  //     var sidePadding = 20;
  //     var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);

  //     ctx.font = "40px " + "Arial";

  //     //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
  //     var stringWidth = ctx.measureText(text).width;
  //     var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

  //     // Find out how much the font can grow in width.
  //     var widthRatio = elementWidth / stringWidth;
  //     var newFontSize = Math.floor(30 * widthRatio);
  //     var elementHeight = chart.innerRadius * 2;

  //     // Pick a new font size so it will not be larger than the height of label.
  //     var fontSizeToUse = Math.min(newFontSize, elementHeight);

  //     var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
  //     var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

  //     var fontSize = (height / 114).toFixed(2);
  //     ctx.font = fontSize + "em Verdana";
  //     ctx.textBaseline = "middle";

  //     ctx.textAlign = "center";
  //     ctx.font = fontSizeToUse + "px " + "Arial";

  //     var textX = Math.round((width - ctx.measureText(text).width) / 2);
  //     var textY = height / 2;

  //     ctx.fillText(text, centerX, centerY);
  //   },
  // });
  const centerTextPlugin = {
    id: "centerText",
    afterDraw: (chart) => {
      const { ctx, width, height } = chart;
      const text = chart.config.data.text;

      if (!text) return; // Skip if text is empty

      // Save context state (do NOT clear the chart)
      ctx.save();

      const sidePadding = 20;
      const sidePaddingCalculated =
        (sidePadding / 100) * (chart.innerRadius * 2);
      const stringWidth = ctx.measureText(text).width;
      const elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;
      const widthRatio = elementWidth / stringWidth;
      const newFontSize = Math.floor(30 * widthRatio);
      const elementHeight = chart.innerRadius * 2;
      const fontSizeToUse = Math.min(newFontSize, elementHeight);

      const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
      const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

      ctx.font = `20px Arial`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      // Draw text on top of the chart
      ctx.fillText(text, centerX, centerY);

      ctx.restore();
    },
  };

  // function getMonthsDifference(date1, date2) {
  //   const year1 = date1.getFullYear();
  //   const year2 = date2.getFullYear();
  //   const month1 = date1.getMonth();
  //   const month2 = date2.getMonth();

  //   return (year2 - year1) * 12 + (month2 - month1);
  // }
  function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  }
  const calculateCompletePercentage = (need, have) => {
    const percentage = (have / need) * 100;
    console.log("percentage complete", percentage, data["Description of Goal"]);
    return parseFloat(percentage).toFixed(2);
  };
  const calculateIncompletePercentage = (need, have) => {
    let percentage = (have / need) * 100;
    percentage = 100 - percentage;
    console.log(
      "percentage incomeplete",
      percentage,
      data["Description of Goal"]
    );
    return parseFloat(percentage).toFixed(2);
  };
  const calculateGoalNeed = (amountNeed, date, inflation) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;
    // const GoalInflationRate = data["Inflation rate for this goal"]
    //   ? data["Inflation rate for this goal"] / 100
    //   : 10; // commented beacuse inflation rate needs to be change according to option coming from tax and inflation
    const goalInflation = inflation && inflation;
    const matchedInflation =
      taxInfo && taxInfo.find((item) => item.name === goalInflation);
    const GoalInflationRate = matchedInflation
      ? (parseFloat(matchedInflation.value) || 0) / 100
      : 0;
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    const NumberofYears = NumberofMonths / 12;
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    // Calculate the number of days between GoalDate and todaysDate
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // Calculate the formula
    // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    const n = 12;
    const result =
      GoalNeedToday * Math.pow(1 + GoalInflationRate / n, n * NumberofYears);
    // const result =
    //   GoalNeedToday *
    //   Math.pow(
    //     1 + GoalInflationRate / 100 / 365,
    //     365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
    //       NumberofMonths
    //   );
    console.log("result", result);
    return parseFloat(result).toFixed(2);
  };
  const labels = data && [
    `Need: $${(data["Dollar Amount Needed"]
      ? calculateGoalNeed(
          data["Dollar Amount Needed"],
          data["Goal Date"] ? data["Goal Date"] : new Date(),
          data["Inflation rate for this goal"] &&
            data["Inflation rate for this goal"]
        )
      : 0
    )
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
    `Have: $${(
      (data.assignAssets && Array.isArray(data.assignAssets)
        ? data.assignAssets.reduce(
            (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
            0
          )
        : 0) +
      (data["Total Monthly Saving for All Goals"]
        ? parseFloat(data["Total Monthly Saving for All Goals"])
        : 0) +
      (data["Amount Received"] && Array.isArray(data["Amount Received"])
        ? data["Amount Received"].reduce(
            (acc, curr) => acc + parseFloat(curr || 0),
            0
          )
        : 0)
    )
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
  ];
  const dataValues = data && [
    // Incomplete percentage calculation
    data["Dollar Amount Needed"]
      ? calculateIncompletePercentage(
          calculateGoalNeed(
            data["Dollar Amount Needed"],
            data["Goal Date"] ? data["Goal Date"] : new Date(),
            data["Inflation rate for this goal"] &&
              data["Inflation rate for this goal"]
          ),
          (data.assignAssets && Array.isArray(data.assignAssets)
            ? data.assignAssets.reduce(
                (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
                0
              )
            : 0) +
            (data["Amount Received"] && Array.isArray(data["Amount Received"])
              ? data["Amount Received"].reduce(
                  (acc, curr) => acc + parseFloat(curr || 0),
                  0
                )
              : 0)
        )
      : 0,

    // Complete percentage calculation
    data["Dollar Amount Needed"]
      ? calculateCompletePercentage(
          calculateGoalNeed(
            data["Dollar Amount Needed"],
            data["Goal Date"] ? data["Goal Date"] : new Date(),
            data["Inflation rate for this goal"] &&
              data["Inflation rate for this goal"]
          ),
          (data.assignAssets && Array.isArray(data.assignAssets)
            ? data.assignAssets.reduce(
                (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
                0
              )
            : 0) +
            (data["Total Monthly Saving for All Goals"]
              ? parseFloat(data["Total Monthly Saving for All Goals"])
              : 0) +
            (data["Amount Received"] && Array.isArray(data["Amount Received"])
              ? data["Amount Received"].reduce(
                  (acc, curr) => acc + parseFloat(curr || 0),
                  0
                )
              : 0)
        )
      : 0,
  ];
  return (
    <React.Fragment>
      <div className="GoalCard3">
        <h1 className="GoalsCardheading">
          {data && data["Description of Goal"]
            ? data["Description of Goal"]
            : "N/A"}
        </h1>
        <Doughnut
          data={{
            labels: labels && labels,
            datasets: [
              {
                label: "Goal Value",
                data: dataValues && dataValues,
                // backgroundColor: chartColors,
                backgroundColor: ["#2A3DA3", "#09A84D"],
              },
            ],
            // text: `${
            //     data &&
            //     data.assignAssets &&
            //     data["Dollar Amount Needed"]
            //       ? Math.min(
            //           ((data.assignAssets && Array.isArray(data.assignAssets)
            //             ? data.assignAssets.reduce((acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0), 0):0) / calculateGoalNeed(data["Dollar Amount Needed"] ,data["Goal Date"] ? data["Goal Date"] : new Date())) * 100,
            //           100
            //         ).toFixed(2) + "%"
            //       : "0.0%" // Fallback to 0% if the values are not present
            //   }`,
            text: `${
              data && data.assignAssets && data["Dollar Amount Needed"]
                ? Math.min(
                    (((data.assignAssets && Array.isArray(data.assignAssets)
                      ? data.assignAssets.reduce(
                          (acc, curr) =>
                            acc + parseFloat(curr.amountUseForGoal || 0),
                          0
                        )
                      : 0) +
                      (data["Total Monthly Saving for All Goals"]
                        ? parseFloat(data["Total Monthly Saving for All Goals"])
                        : 0) +
                      (data["Amount Received"] &&
                      Array.isArray(data["Amount Received"])
                        ? data["Amount Received"].reduce(
                            (acc, curr) => acc + parseFloat(curr || 0),
                            0
                          )
                        : 0)) /
                      calculateGoalNeed(
                        data["Dollar Amount Needed"],
                        data["Goal Date"] ? data["Goal Date"] : new Date(),
                        data["Inflation rate for this goal"] &&
                          data["Inflation rate for this goal"]
                      )) *
                      100,
                    100
                  ).toFixed(2) + "%"
                : "0.0%" // Fallback to 0% if the values are not present
            }`,
            // text: `${
            //   data &&
            //   data["Amount to use for this goal"] &&
            //   data["Dollar Amount Needed"]
            //     ? (((Array.isArray(data["Amount to use for this goal"]) ? data["Amount to use for this goal"].reduce((acc, curr) => acc + curr, 0) : 0 )/data["Dollar Amount Needed"])* 100).toFixed(2) + "%"
            //     : "0%"  // Fallback to 0% if the values are not present
            // }`,
          }}
          options={{
            // cutoutPercentage: 70,
            responsive: true,
            legend: {
              display: true,
              position: "right",
            },
          }}
          plugins={[centerTextPlugin]}
        />
      </div>
      <div
        className="goalCard2"
        style={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <h1 className="GoalsCardheading">Goal Details</h1>
          <div className="filterIcons">
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        history.push(
                          `/goals_add/attributes/${data.module}/${data.id}/view`
                        );
                      }}
                    >
                      View
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        history.push(
                          `/goals_add/attributes/${data.module}/${data.id}`
                        );
                      }}
                    >
                      Update
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        deleteGoal(data.id, data);
                      }}
                    >
                      Delete
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
                style={{ padding: "0px 1rem" }}
              >
                <img src={menuIcon} height={15} width={4} alt="icon"></img>
              </a>
            </Dropdown>{" "}
          </div>
        </div>
        <div className="budgetRow">
          <div>
            <div className="budgetReportrow1" style={{ gap: "1rem" }}>
              <div className="budgetReportrowData">
                <span className="budgetreportTitle"> Amount Needed</span>
                <span className="budgetreportsubTitle2">
                  $
                  {(() => {
                    const need =
                      data && data["Dollar Amount Needed"]
                        ? calculateGoalNeed(
                            data["Dollar Amount Needed"],
                            data["Goal Date"] || new Date(),
                            data["Inflation rate for this goal"] &&
                              data["Inflation rate for this goal"]
                          )
                        : 0;

                    const have =
                      (data &&
                      data.assignAssets &&
                      Array.isArray(data.assignAssets)
                        ? data.assignAssets.reduce(
                            (acc, curr) =>
                              acc + parseFloat(curr.amountUseForGoal || 0),
                            0
                          )
                        : 0) +
                      (data["Total Monthly Saving for All Goals"]
                        ? parseFloat(data["Total Monthly Saving for All Goals"])
                        : 0) +
                      (data &&
                      data["Amount Received"] &&
                      Array.isArray(data["Amount Received"])
                        ? data["Amount Received"].reduce(
                            (acc, curr) => acc + parseFloat(curr || 0),
                            0
                          )
                        : 0);

                    const amountNeeded = Math.max(need - have, 0); // prevent negative display

                    return amountNeeded
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  })()}
                </span>
              </div>
              <div className="budgetReportrowData">
                <span className="budgetreportTitle">Asset Assign to Goal</span>
                <span className="budgetreportsubTitle2">
                  {
                    data &&
                    data.assignAssets &&
                    Array.isArray(data.assignAssets)
                      ? data.assignAssets.map((item, index) => (
                          <span key={index}>
                            {index + 1} {item.asset}
                            {index < data.assignAssets.length - 1 && ", "}{" "}
                            {/* Adds a comma between items */}
                          </span>
                        ))
                      : data && data.assignAssets
                      ? data.assignAssets
                      : "N/A" // If it's not an array, just render it directly
                  }
                </span>
              </div>
              <div className="budgetReportrowData">
                <span className="budgetreportTitle">Goals Date</span>
                <span className="budgetreportsubTitle2">
                  {`${
                    data && data["Goal Date"]
                      ? moment(data["Goal Date"]).format("MM/DD/YYYY")
                      : "N/A"
                  }`}
                </span>
              </div>
              <div className="budgetReportrowData">
                <span className="budgetreportTitle">Inflation Rate</span>
                <span className="budgetreportsubTitle2">
                  {" "}
                  {data && data["Inflation rate for this goal"]
                    ? data["Inflation rate for this goal"]
                    : 0}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <NewLoader isLoading={loading} /> */}
      </div>
    </React.Fragment>
  );
};
